/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ObservabilitySummary,
  ObservabilitySummary$inboundSchema,
} from "./observabilitysummary.js";
import {
  TimeSeriesBucket,
  TimeSeriesBucket$inboundSchema,
} from "./timeseriesbucket.js";
import { ToolMetric, ToolMetric$inboundSchema } from "./toolmetric.js";

/**
 * Result of observability overview query
 */
export type GetObservabilityOverviewResult = {
  /**
   * Aggregated summary metrics for a time period
   */
  comparison: ObservabilitySummary;
  /**
   * The time bucket interval in seconds used for the time series data
   */
  intervalSeconds: number;
  /**
   * Aggregated summary metrics for a time period
   */
  summary: ObservabilitySummary;
  /**
   * Time series data points
   */
  timeSeries: Array<TimeSeriesBucket>;
  /**
   * Top tools by call count
   */
  topToolsByCount: Array<ToolMetric>;
  /**
   * Top tools by failure rate
   */
  topToolsByFailureRate: Array<ToolMetric>;
};

/** @internal */
export const GetObservabilityOverviewResult$inboundSchema: z.ZodMiniType<
  GetObservabilityOverviewResult,
  unknown
> = z.pipe(
  z.object({
    comparison: ObservabilitySummary$inboundSchema,
    interval_seconds: z.int(),
    summary: ObservabilitySummary$inboundSchema,
    time_series: z.array(TimeSeriesBucket$inboundSchema),
    top_tools_by_count: z.array(ToolMetric$inboundSchema),
    top_tools_by_failure_rate: z.array(ToolMetric$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "interval_seconds": "intervalSeconds",
      "time_series": "timeSeries",
      "top_tools_by_count": "topToolsByCount",
      "top_tools_by_failure_rate": "topToolsByFailureRate",
    });
  }),
);

export function getObservabilityOverviewResultFromJSON(
  jsonString: string,
): SafeParseResult<GetObservabilityOverviewResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetObservabilityOverviewResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetObservabilityOverviewResult' from JSON`,
  );
}
